import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EFonts } from 'libs/styles/styling';
import React from 'react';
import styled, { css } from 'styled-components/macro';

type MessageType = 'info' | 'warning' | 'idea' | 'note';

interface Props {
    children: React.ReactNode;
    type: MessageType;
    className?: string;
}

export const Message = (props: Props): JSX.Element => {
    const getIconDefinition = (): IconProp => {
        if (props.type === 'info') {
            return ['fal', 'info-circle'];
        } else if (props.type === 'note') {
            return ['fal', 'info-circle'];
        } else if (props.type === 'warning') {
            return ['fal', 'triangle-exclamation'];
        } else if (props.type === 'idea') {
            return ['fal', 'lightbulb'];
        }
    };

    return (
        <S_Message className={props.className} $type={props.type}>
            <S_Icon icon={getIconDefinition()} />
            <S_Text>{props.children}</S_Text>
        </S_Message>
    );
};

const S_Message = styled.div<{ $type: MessageType }>`
    ${(props) => {
        if (props.$type === 'info') {
            return css`
                background: #fefde8;
                border: 1px solid #b9b66f;
            `;
        } else if (props.$type === 'note') {
            return css`
                background: #f4f4f4;
                border: 1px solid #dadada;
            `;
        } else if (props.$type === 'warning') {
            return css`
                background: #ffe0bd;
                border: 1px solid #a6633c;
            `;
        } else if (props.$type === 'idea') {
            return css`
                background: #e6f1ff;
                border: 1px solid #3e7fff;
            `;
        }
    }}
    border-radius: 7px;
    padding: 12px 12px 12px 16px;
    color: #141c54;
    width: 100%;
    font-size: 13px;
    display: flex;
    line-height: 19px;
`;

const S_Icon = styled(FontAwesomeIcon)`
    margin: 0 13px 0 0;
    color: #141c54;
    width: 20px;
    font-size: 20px;
`;

const S_Text = styled.div`
    font-family: ${EFonts.Regular};
    margin: 0px 0 0 0;
    strong,
    b {
        font-family: ${EFonts.Medium};
    }
`;
